// const mainColors = [ "#e33a1a", "#f6bc2e", "#faf958", "#31952f",
//   "#07532d",
//   "#1378c8", "#1e3762", "#8439c4", "#c62b7c" ]

// https://learnui.design/tools/data-color-picker.html#single

const redColors = [
  "#e33a1a",
  "#e95330",
  "#ef6944",
  "#f47d59",
  "#f8906e",
  "#fca284",
  "#feb49b",
  "#ffc6b2",
  "#ffd8ca",
]

// const greyColors = [
//   "#777",
//   "#aaa",
// ]

const orangeColors = [
  "#ff9924",
  "#fda83c",
  "#fbb552",
  "#fac268",
  "#f9cf7f",
  "#f9da96",
  "#fae5ae",
  "#fcefc7",
  "#fff9df",
]

const greenColors = [
  "#31952f",
  "#4aa043",
  "#5faa56",
  "#73b568",
  "#86bf7b",
  "#98ca8e",
  "#abd5a1",
  "#bddfb4",
  "#cfeac8",
]

const darkGreenColors = [
  "#07532d",
  "#276540",
  "#3f7753",
  "#568967",
  "#6c9c7c",
  "#84af91",
  "#9bc2a7",
  "#b3d6bd",
  "#cbead4",
]

const lightBlueColors = [
  "#1378c8",
  "#3e85cf",
  "#5892d6",
  "#6e9fdd",
  "#83ace4",
  "#97baeb",
  "#aac7f1",
  "#bdd5f8",
  "#d0e3ff",
]

const darkBlueColors = [
  "#004c6d",
  "#255e7e",
  "#3d708f",
  "#5383a1",
  "#6996b3",
  "#7faac6",
  "#94bed9",
  "#abd2ec",
  "#c1e7ff",
]

const purpleColors = [
  "#8439c4",
  "#984dca",
  "#aa61d0",
  "#bb75d7",
  "#ca8ade",
  "#d99ee6",
  "#e7b3ee",
  "#f3c8f6",
  "#ffdeff",
]

const pinkColors = [
  "#f23598",
  "#f450a8",
  "#f665b8",
  "#f879c6",
  "#f98ad4",
  "#fa9be0",
  "#fbacec",
  "#fdbcf6",
  "#ffcbff",
]

const mainColors = [
  redColors[0],
  greenColors[0],
  darkGreenColors[0],
  lightBlueColors[0],
  darkBlueColors[0],
  purpleColors[0],
  pinkColors[0],
  orangeColors[0],
]

// const colorSource = [ "#e6194b", "#3cb44b", "#ffe119", "#4363d8", "#f58231", "#911eb4", "#46f0f0", "#f032e6", "#bcf60c", "#fabebe", "#008080", "#e6beff", "#9a6324", "#fffac8", "#800000", "#aaffc3", "#808000", "#ffd8b1", "#000075", "#808080", "#ffffff", "#000000"]

// 1: Inkomen           green
// 2: Wonen             red
// 3: Huishouden        green
// 4: Vervoer           darkGreen
// 5: Diensten          lightBlue
// 7: Spullen           darkBlue
// 8: Vrije tijd        purple
// 9: Overige uitgaven  pink
// 67:Ongecategoriseerd orange

const colorListForCategoryId: Record<number, string[]> = {
  1: greenColors,
  2: redColors,
  69: greenColors,
  4: darkGreenColors,
  5: lightBlueColors,
  7: darkBlueColors,
  8: purpleColors,
  9: pinkColors,
  67: orangeColors
}

const colorForTopLevelCategoryId: Record<number, string> = {
  1: greenColors[0],
  2: redColors[0],
  69: greenColors[0],
  4: darkGreenColors[0],
  5: lightBlueColors[0],
  7: darkBlueColors[0],
  8: purpleColors[0],
  9: pinkColors[0],
  67: orangeColors[0]
}

export function getCategoryColors(categoryId: number | undefined, count: number): string[] {
  if (categoryId === undefined) return getColorsForList(mainColors, count)
  return getColorsForList(colorListForCategoryId[categoryId], count)
}

export function getColors(count: number): string[] {
  return getColorsForList(mainColors, count)
}

function getColorsForList(colorList: string[], count: number): string[] {
  const colors = []
  for (let i = 0; i < count; i++) colors.push(colorList[i % colorList.length])
  return colors
}

export function getColorForIndex(index: number): string {
  return mainColors[index % mainColors.length]
}

export function getColorForTopLevelCategory(categoryId: number): string {
  return colorForTopLevelCategoryId[categoryId]
}